import React, { PureComponent } from 'react';
import styled from 'styled-components';

const DivOuter = styled.div`
display: flex;
flex-direction: column;
`
const HomePageDiv = styled.div`
  display: flex;
  font-size: 17px;
  font-weight: 700;
  line-height: 24.62px;
  color: rgba(177, 177, 177, 1);
  margin-bottom: 32px;
  word-break: break-all;
  &:before {
    content: "";
    background: url(../images/internet.png) no-repeat center;
    width: 24px;
    height: 24px;
    margin-top: 2px;
    margin-left: -5px;
    margin-right: 16px;
  }
`;
const MailDiv = styled.div`
  display: flex;
  font-size: 17px;
  font-weight: 700;
  line-height: 24.62px;
  color: rgba(177, 177, 177, 1);
  margin-bottom: 32px;
  word-break: break-all;
  &:before {
    content: "";
    background: url(../images/mail.png) no-repeat center;
    width: 24px;
    height: 24px;
    margin-top: 2px;
    margin-left: -5px;
    margin-right: 16px;
  }
`;
const AdressDiv = styled.div`
  display: flex;
  font-size: 17px;
  font-weight: 700;
  line-height: 24.62px;
  color: rgba(177, 177, 177, 1);
  margin-bottom: 32px;
  word-break: break-all;
  &:before {
    content: "";
    background: url(../images/position.png) no-repeat center;
    width: 24px;
    height: 24px;
    margin-top: 2px;
    margin-left: -5px;
    margin-right: 16px;
  }
`;
const PhoneDiv = styled.div`
  display: flex;
  font-size: 17px;
  font-weight: 700;
  line-height: 24.62px;
  color: rgba(177, 177, 177, 1);
  margin-bottom: 32px;
  word-break: break-all;
  &:before {
    content: "";
    background: url(../images/tel.png) no-repeat center;
    width: 24px;
    height: 24px;
    margin-top: 2px;
    margin-left: -5px;
    margin-right: 16px;
  }
`;
class InFormAtom extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {

        }
    }

    render() {
        return (
          <DivOuter>
              <MailDiv>wingardium@lab254.com</MailDiv>
              <HomePageDiv>lab254.com </HomePageDiv>
              <AdressDiv>서울시 강서구 마곡동 757-3,1117호</AdressDiv>
              <PhoneDiv>070-7543-2541</PhoneDiv>
          </DivOuter>
        );
    }
}

export default InFormAtom

// 